function Angola({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_500)">
  <path d="M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16C31.3044 16 16 18.0869 16 18.0869L0 16Z" fill="#D80027"/>
  <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16" fill="black"/>
  <path d="M13.806 12.7257L15.1624 13.7101L14.6455 15.3043L16.0009 14.3183L17.3574 15.3027L16.8385 13.7089L18.1938 12.7231L16.5178 12.7241L15.9989 11.1304L15.482 12.7246L13.806 12.7257Z" fill="#FFDA44"/>
  <path d="M20 9.07158C18.7391 8.34364 17.3606 8.00008 16 8.00245V10.089C17.0056 10.0871 18.0245 10.3409 18.9565 10.879C21.7801 12.5093 22.751 16.1328 21.1207 18.9564C19.4905 21.78 15.8671 22.7509 13.0434 21.1207C12.2208 20.6458 11.5567 20.0009 11.0672 19.2567L9.32495 20.4069C9.98726 21.4138 10.887 22.2854 12 22.9279C15.8202 25.1336 20.7225 23.82 22.9281 19.9998C25.1337 16.1795 23.8202 11.2772 20 9.07158Z" fill="#FFDA44"/>
  <path d="M11.3868 14.6084C10.8336 15.6196 11.205 16.8878 12.2162 17.4409L18.9942 21.1446C18.5333 21.9872 18.7781 23.0128 19.6207 23.4737L21.4516 24.4753C22.2941 24.9363 23.3511 24.6268 23.812 23.7841L24.8136 21.9533L11.3868 14.6084Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Angola;
